The address that represents the preferred location.
